import type { CustomIconProps } from '../types';

const Dislike = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '18'}
        height={height ?? '16'}
        viewBox="0 0 18 16"
        fill="none"
    >
        <path
            d="M9 0.999999L9.28235 1.23569C15.3529 6.18518 17 7.92929 17 10.7576C17 13.1145 15.1176 15 12.7647 15C10.8353 15 9.75294 13.9158 9 13.0673C8.24706 13.9158 7.16471 15 5.23529 15C2.88235 15 1 13.1145 1 10.7576C1 7.92929 2.64706 6.18518 8.71765 1.23569L9 0.999999ZM12.7647 14.0572C14.6 14.0572 16.0588 12.596 16.0588 10.7576C16.0588 8.35354 14.5529 6.75084 9 2.22559C3.44706 6.75084 1.94118 8.35353 1.94118 10.7576C1.94118 12.596 3.4 14.0572 5.23529 14.0572C6.88235 14.0572 7.77647 13.0673 8.48235 12.266L9 11.6532L9.51765 12.266C10.2235 13.0673 11.1176 14.0572 12.7647 14.0572Z"
            fill="#414042"
            stroke="#414042"
            strokeWidth="0.3"
        />
    </svg>
);

export default Dislike;
